import {
  START_LOADING,
  END_LOADING,
  FETCH_ITEMS,
  FETCH_ITEMS_USER,
  ADD_NEW_ITEM,
  ADD_NEW_ITEMS,
  UPDATE_ITEM,
  DELETE_ITEM,
  DELETE_ITEMS_BY_CATEGORY,
  CREATE_FUTURE_PRICE_LIST,
  FETCH_FUTURE_PRICE_LIST,
  UPDATE_FUTURE_PRICE,
  DELETE_FUTURE_PRICE,
  UPSERT_ITEMS,
  REMOVE_ITEMS,
  REPLACE_ITEMS_FROM_SERVER,
} from "../actions/constants";

const items = (state = { isLoading: true, items: [] , futurePrices: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ITEMS:
      
      return {
        ...state,
        items: action.payload,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_ITEMS_USER:
      return { ...state, items: action.payload };

    // New items go at the FRONT, not the end: getItems (server/controllers/
    // items.js) returns the catalog newest-first ({_id: -1}), which is the
    // order the POS grid and Items list render in as-is. Appending put a just-
    // created item after every existing one - bottom of a long POS grid / last
    // page of the Items list - so it looked like it hadn't been added until a
    // refresh re-fetched it in its real (top) position.
    case ADD_NEW_ITEM:
      return { ...state, items: [action.payload, ...state.items] };
    case ADD_NEW_ITEMS:
      // Bulk adds arrive oldest-first; reversed so the newest ends up on top,
      // matching the server's ordering.
      return { ...state, items: [...[...action.payload].reverse(), ...state.items] };

    // Live inventory: items another till/tab created or changed. Existing
    // rows are replaced in place (keeping list order); unknown ones are new
    // and go on top, same as ADD_NEW_ITEM.
    case UPSERT_ITEMS: {
      if (!action.payload?.length) return state;
      const incoming = new Map(action.payload.map((item) => [item._id, item]));
      const updated = state.items.map((item) => {
        const fresh = incoming.get(item._id);
        if (!fresh) return item;
        incoming.delete(item._id);
        return fresh;
      });
      return { ...state, items: [...incoming.values(), ...updated] };
    }
    case REMOVE_ITEMS: {
      const ids = new Set(action.payload || []);
      if (!ids.size) return state;
      return { ...state, items: state.items.filter((item) => !ids.has(item._id)) };
    }
    // Full re-read after a reconnect / missed changes. Items that were not in
    // the store when the re-read started but are now (created meanwhile) are
    // kept even if the server snapshot predates them.
    case REPLACE_ITEMS_FROM_SERVER: {
      const { items: serverItems, idsBefore } = action.payload;
      const serverIds = new Set(serverItems.map((item) => item._id));
      const createdMeanwhile = state.items.filter(
        (item) => !serverIds.has(item._id) && !idsBefore.has(item._id)
      );
      return { ...state, items: [...createdMeanwhile, ...serverItems] };
    }

    case UPDATE_ITEM:
      return {
        ...state,
        items: state.items.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };
    case DELETE_ITEM:
      return {
        ...state,
        items: state.items.filter((item) => item._id !== action.payload),
      };
    case DELETE_ITEMS_BY_CATEGORY:
      
      const { id } = action.payload;
      return {
        ...state,
        items: state.items.filter((item) => item.category?.categoryId !== id),
      };

      case CREATE_FUTURE_PRICE_LIST:
      return {
        ...state,
        futurePrices: [...state.futurePrices, ...action.payload],
      };
    case FETCH_FUTURE_PRICE_LIST:
      return {
        ...state,
        futurePrices: action.payload,
      };
    case UPDATE_FUTURE_PRICE:
      return {
        ...state,
        futurePrices: state.futurePrices.map((price) =>
          price._id === action.payload._id ? action.payload : price
        ),
      };
    case DELETE_FUTURE_PRICE:
      return {
        ...state,
        futurePrices: state.futurePrices.filter((price) => price._id !== action.payload),
      };
    default:
      return state;
  }
};

export default items;
